import { render } from "./FansRankingTabs.vue?vue&type=template&id=218cba39"
import script from "./FansRankingTabs.vue?vue&type=script&lang=js"
export * from "./FansRankingTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__